import { render } from "./Home.vue?vue&type=template&id=75d597a4"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"
script.render = render

export default script